export const publicApiEndpoint = process.env.REACT_APP_APIGATEWAY;
